import { Component, Input, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DataProtectionVariables } from '../../../dataprotection-common/dataprotection-variables';
import { storageRender, policyRender } from '../../../dataprotection-common/common-renderers';

import { VirtualMachineService } from './virtual-machine-details-vc.service';
import { JobsNotifierService } from '../../../../../services/job-notifier.service';
import { JobConstants } from '../../../../../../common/utils/job-constants';
import { Subscription } from 'rxjs/Rx';
import { RefreshSharedService } from '../../../../../refresh-shared-service';

@Component({
    selector: 'dps-virtual-machine-details-vc',
    providers: [ VirtualMachineService ],
    styles: [require('./virtual-machine-details-vc.scss')],
    template: require('./virtual-machine-details-vc.html')
})
export class VirtualMachineDetails {
    @Input() entity: any;

    private subscription: any;

    private vm: any;
    private policyData: any = {};
    private loaded: boolean;
    private isPolicySet: boolean;

    private vmName: string;
    private vcHost: string;
    private lastSuccessfulBackupTime: string = '-';
    private restorePointCount = '0';

    private policy: any;
    private storageConsumed: any;

    private isModalClosable: boolean = true;

    private isAddPolicyModalVisible: boolean;
    private applyPolicyModalMode: String;
    private applyPolicyModalHeader: String;

    private isDeletePolicyModalVisible: boolean;
    private deletePolicyModalHeader: String;
    private deletePolicyModalMode: String;

    private isRestorePointsModalVisible: boolean;
    private restorePointModalHeader: String;
    private restorePointsModalMode: String;

    private isConfigureEmailModalVisible: boolean;

    private isAdhocBackupModalVisible: boolean;
    private adhocBackupModalHeader: String;
    private rsService: RefreshSharedService;
    private refreshSubscription: Subscription;
    private currentClassName: string = '';

    constructor(private translate:TranslateService,
                private activatedRoute: ActivatedRoute,
                private virtualMachineService: VirtualMachineService,
                private jobNotifierService: JobsNotifierService,
                private rss: RefreshSharedService) {
        this.isPolicySet = false;
        this.isAddPolicyModalVisible = false;
        this.isDeletePolicyModalVisible = false;
        this.isRestorePointsModalVisible = false;
        this.isAdhocBackupModalVisible = false;
        translate.use(GlobalVariables.LOCALE);
        this.rsService = rss;
        this.currentClassName = 'VirtualMachineDetails';
    }

    ngOnInit() {
      this.refreshSubscription = this.rsService.getRefreshParam()
      .subscribe (
        item => {
          this.handleEmittedValues(item);
      });

    this.rsService.setParam({
        'loadedComponent': this.currentClassName,
        'detailPageIDName': '',
        'shouldReloadInventoryTree': true
      });

        if (this.entity) {
            this.subscription = this.jobNotifierService.getCompletedJobs(JobConstants.SERVICES['DataProtectionServiceJob']).subscribe(jobs => {
                    this.handleJobs(jobs);
                },
                error => {},
                () => {}
            );
        }
    }

    handleEmittedValues(item) {
    if (item.loadedComponent === this.currentClassName) {
        this.refresh();
    }
  }

    handleJobs(jobs) {
        // Triggering Refresh only if the jobs received are of some interest to this virtual machine
        for (let job of jobs) {
            if (job.hasOwnProperty('workflowType')) {
                if (job.workflowType === 'VM_ADHOC_BACKUP_WORKFLOW' ||
                    job.workflowType === 'REFRESH_VM_RESTORE_POINTS' ||
                    job.workflowType === 'VM_CLIENT_DELETION_WORKFLOW') {
                    if (job.entityId === this.entity.entity_id) {
                        this.refresh();
                        break;
                    }
                }
            }
        }
    }

    onAddPolicyClick = (event) => {
        this.applyPolicyModalHeader = this.translate.instant('vcDpsModule.applyPolicy.popupHeaderApplyPolicy') + this.entity.name;
        this.applyPolicyModalMode = DataProtectionVariables.POLICY_POPUP_MODES['ADD_VM_POLICY'];
        this.isAddPolicyModalVisible = true;
    };

    onEditPolicyClick = (event) => {
        this.applyPolicyModalHeader = this.translate.instant('vcDpsModule.applyPolicy.popupHeaderEditPolicy') + this.entity.name;
        this.applyPolicyModalMode = DataProtectionVariables.POLICY_POPUP_MODES['UPDATE_VM_POLICY'];
        this.isAddPolicyModalVisible = true;
    };

    onAddPolicyClose = (emittedData) => {
        if (!emittedData) {
            this.isAddPolicyModalVisible = false;
            this.isModalClosable = true;
        } else if (emittedData.status === 'pending') {
            this.isModalClosable = false;
        } else if (emittedData.status === 'success') {
            this.isAddPolicyModalVisible = false;
            this.isModalClosable = true;
            this.getVirtualMachineDetails(this.entity.entity_id, this.entity.vcenter_instanceId);
        } else {
            this.isModalClosable = true;
        }
    };

    onDeletePolicyClick = (event) => {
        this.deletePolicyModalHeader = this.translate.instant('vcDpsModule.deletePolicy.vm.popupHeader');
        this.deletePolicyModalMode = DataProtectionVariables.POLICY_POPUP_MODES['DELETE_VM_POLICY'];
        this.isDeletePolicyModalVisible = true;
    };

    onDeletePolicyClose = (emittedData) => {
        if (!emittedData) {
            this.isDeletePolicyModalVisible = false;
            this.isModalClosable = true;
        } else if (emittedData.status === 'pending') {
            this.isModalClosable = false;
        } else if (emittedData.status === 'success') {
            this.isDeletePolicyModalVisible = false;
            this.isModalClosable = true;
            this.getVirtualMachineDetails(this.entity.entity_id, this.entity.vcenter_instanceId);
        } else {
            this.isModalClosable = true;
        }
    };

    onRestorePointsClick = (event) => {
        this.restorePointModalHeader = this.translate.instant('vcDpsModule.restorePoints.popupHeader') + this.entity.name;
        this.restorePointsModalMode = DataProtectionVariables.RESTORE_MODES['VM'];
        this.isRestorePointsModalVisible = true;
    };

    onRestorePointsModalClose = (emittedData) => {
        this.isRestorePointsModalVisible = false;
    };

    onAdhocBackupClick = (event) => {
        this.adhocBackupModalHeader = this.translate.instant('vcDpsModule.adhocBackup.popupHeader') + this.entity.name;
        this.isAdhocBackupModalVisible = true;
    };

    onAdhocBackupClose = (emittedData) => {
        if (!emittedData) {
            this.isAdhocBackupModalVisible = false;
            this.isModalClosable = true;
        } else if (emittedData.status === 'pending') {
            this.isModalClosable = false;
        } else if (emittedData.status === 'success') {
            this.isAdhocBackupModalVisible = false;
            this.isModalClosable = true;
        } else {
            this.isModalClosable = true;
        }
    };

    onConfigureEmailClick = (event) => {
        this.isConfigureEmailModalVisible = true;
    }

    onConfigureEmailClose = (emittedData) => {
        if (!emittedData) {
            this.isConfigureEmailModalVisible = false;
            this.isModalClosable = true;
        } else if (emittedData.status === 'pending') {
            this.isModalClosable = false;
        } else if (emittedData.status === 'success') {
            this.isConfigureEmailModalVisible = false;
            this.isModalClosable = true;
        } else {
            this.isModalClosable = true;
        }
    }

    refresh() {
        if (this.entity &&
            this.entity.entity_id &&
            this.entity.vcenter_instanceId) {
            this.getVirtualMachineDetails(this.entity.entity_id, this.entity.vcenter_instanceId);
        }
    }

    ngOnChanges(changes) {
        if (changes.entity &&
            changes.entity.currentValue &&
            changes.entity.currentValue.entity_id &&
            changes.entity.currentValue.vcenter_instanceId) {
            this.getVirtualMachineDetails(changes.entity.currentValue.entity_id, changes.entity.currentValue.vcenter_instanceId);
            this.vmName = changes.entity.currentValue.name;
            this.vcHost = changes.entity.currentValue.vcHost;
        }
    }

    setVirtualMachineDetails(details) {
        this.vm = details
        if (this.vm && this.vm.schedule) {
            this.policyData['schedule'] = JSON.parse(JSON.stringify(this.vm.schedule));
            this.policyData['retention'] = JSON.parse(JSON.stringify(this.vm.retention));
            this.isPolicySet = true;
        } else {
            this.isPolicySet = false;
        }
        this.policy = policyRender('', '', this.vm);
        this.storageConsumed = storageRender('', '', this.vm);
        if (this.vm && this.vm.statistics && this.vm.statistics.lastSuccessfulBackupTime) {
            this.lastSuccessfulBackupTime = this.vm.statistics.lastSuccessfulBackupTime;
        }
        if (this.vm && this.vm.statistics && this.vm.statistics.restorePointCount) {
            this.restorePointCount = this.vm.statistics.restorePointCount;
        }
    }

    getVirtualMachineDetails(id, vcId) {
        this.loaded = false;
        this.virtualMachineService.getVirtualMachineDetails(id, vcId).subscribe(
        results => this.setVirtualMachineDetails(results),
        error => {
            this.logError(error, 'get vm details');
            this.loaded = true;
        },
        () => {
            this.logOperationCompleted('get vm details');
            this.loaded = true;
        }
        );
    }

    logError(error, origin: String = '') {
        console.error('Error: ', error, (origin !== '') ? ' Error from ' + origin : '');
    }

    logOperationCompleted(msg: string) {
        console.log('Operation Completed: ', msg);
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.jobNotifierService.unsubscribeService(JobConstants.SERVICES['DataProtectionServiceJob']);
        }

        this.rsService.resetParam();
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/manage/virtual-machine/virtual-machine-details-vc.component.ts